import { CommonLaboratoryDatasource } from '@/shared/resources/datasources/common/common-laboratory-datasource'
import { ShipmentsGridPendingToSendDatasource } from '@/modules/shipments-module/components/grid/datasources/impl/shipments-grid-pending-to-send.datasource'
import { ShipmentsGridPendingToReceiveDatasource } from '@/modules/shipments-module/components/grid/datasources/impl/shipments-grid-pending-to-receive.datasource'
import { ShipmentsGridSentDatasource } from '@/modules/shipments-module/components/grid/datasources/impl/shipments-grid-sent.datasource'
import { ShipmentsGridReceivedDatasource } from '@/modules/shipments-module/components/grid/datasources/impl/shipments-grid-received.datasource'
import { ShipmentsGridReturningTypes } from '@/modules/shipments-module/components/grid/shipments-grid.model'
import { StrictNullable } from '@/shared/types/app.types'

export enum ShipmentsGridType {
    PENDING_TO_SENT = 'PENDING_TO_SENT',
    PENDING_TO_RECEIVE = 'PENDING_TO_RECEIVE',
    SENT = 'SENT',
    RECEIVED = 'RECEIVED'
}

class ShipmentsGridDatasourceFactory {
    getDatasource(
        laboratoryId: number,
        gridType: ShipmentsGridType
    ): StrictNullable<CommonLaboratoryDatasource<ShipmentsGridReturningTypes>> {
        switch (gridType) {
        case ShipmentsGridType.PENDING_TO_SENT:
            return new ShipmentsGridPendingToSendDatasource(laboratoryId)
        case ShipmentsGridType.PENDING_TO_RECEIVE:
            return new ShipmentsGridPendingToReceiveDatasource(laboratoryId)
        case ShipmentsGridType.SENT:
            return new ShipmentsGridSentDatasource(laboratoryId)
        case ShipmentsGridType.RECEIVED:
            return new ShipmentsGridReceivedDatasource(laboratoryId)
        }
        return null
    }
}
export const shipmentsGridDatasourceFactory = new ShipmentsGridDatasourceFactory()
